
'use client';
import Link from 'next/link';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ 
      marginTop: '100px',
      backgroundColor: 'var(--background-color)' 
    }}>
      {/* Der Verlaufsstreifen */}
      <div className="footer-gradient-bar"></div>

      <div className="container" style={{ textAlign: 'center', padding: '60px 0 30px' }}>
        <p style={{ marginBottom: '20px', opacity: 0.7 }}>
          © {currentYear} bodybalance norderstedt
        </p>
        <nav style={{ display: 'flex', justifyContent: 'center', gap: '30px' }}>
          <Link href="/impressum" className="footer-link">Impressum</Link>
          <Link href="/datenschutz" className="footer-link">Datenschutz</Link>
        </nav>
      </div>
    </footer>
  );
}